import * as amplitude from '@amplitude/unified';

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;

  amplitude.initAll('463f38ecd14f1b346892ed0818098326', {
    analytics: {
      autocapture: {
        elementInteractions: true,
        pageViews: true,
        sessions: true,
        formInteractions: true,
      },
    },
    sessionReplay: {
      sampleRate: 0.1,
    },
  });
}

export { amplitude };